(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2169],{

/***/ 7552:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/customizing-products/new",
      function () {
        return __webpack_require__(86980);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ downloadsAPI; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var downloadsAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].DOWNLOADS */ .Z.DOWNLOADS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function downloadsAPI(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 10289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MB": function() { return /* binding */ fileDownloadHelper; },
/* harmony export */   "b5": function() { return /* binding */ pdfDownloadHelper; }
/* harmony export */ });
/* unused harmony export excelDownloadHelper */
/* harmony import */ var _pages_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44754);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11769);


// excel 파일 다운로드 반환 함수
var excelDownloadHelper = function(file) {
    var blob = new Blob([
        file.data
    ], {
        type: file.headers["content-type"],
        encoding: "UTF-8"
    });
    // 파일명 디코딩
    var name = decodeURI(file.headers["content-disposition"]);
    if (window.navigator.msSaveOrOpenBlob) {
        // IE 10+는 해당 함수 제공
        window.navigator.msSaveOrOpenBlob(blob);
    } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.target = "_self";
        if (name) link.download = name.split("=")[1];
        link.click();
        window.URL.revokeObjectURL(link); //메모리 누수 방지
    }
};
// pdf 파일 다운로드 반환 함수
var pdfDownloadHelper = function(file) {
    var blob = new Blob([
        file.data
    ], {
        type: file.headers["content-type"],
        encoding: "UTF-8"
    });
    // 파일명 디코딩
    var name = decodeURI(file.headers["content-disposition"]);
    // fileName = getFileName(name);
    if (window.navigator.msSaveOrOpenBlob) {
        // IE 10+는 해당 함수 제공
        window.navigator.msSaveOrOpenBlob(blob);
    } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.target = "_self";
        if (name) link.download = name.split('"')[1];
        link.click();
        window.URL.revokeObjectURL(link); //메모리 누수 방지
    }
};
// 파일 다운로드 반환 함수
var fileDownloadHelper = function(fileUrl) {
    var fileName = (0,_helper__WEBPACK_IMPORTED_MODULE_1__/* .getFileName */ .UO)(fileUrl);
    var a = document.createElement("a");
    a.href = fileUrl;
    a.download = fileName;
    a.target = "_blank";
    a.click();
};


/***/ }),

/***/ 86980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customizing_products_new; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./redux/action/confirm.js
var action_confirm = __webpack_require__(94184);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./api/packagingBasket.js
var packagingBasket = __webpack_require__(38172);
// EXTERNAL MODULE: ./api/getUserInfo.js + 3 modules
var getUserInfo = __webpack_require__(36897);
// EXTERNAL MODULE: ./api/packaging.js
var packaging = __webpack_require__(82313);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(35632);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./common/util/customizingSchema.js

var CustomizingSchema = yup_es/* object */.Ry({
});

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./components/customizing/customizingProducts/CustomizingCate.js
var CustomizingCate = __webpack_require__(30075);
// EXTERNAL MODULE: ./components/customizing/customizingProducts/Customizing.styles.js
var Customizing_styles = __webpack_require__(85140);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/esm/embla-carousel-react.esm.js + 2 modules
var embla_carousel_react_esm = __webpack_require__(89382);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./style/Customizing/CustomizingProducts/ImageSliderStyle.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 48rem;\n  margin: auto;\n  position: relative;\n  --slide-height: 19rem;\n  --slide-spacing: 1rem;\n  --slide-size: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  touch-action: pan-y pinch-zoom;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 var(--slide-size);\n  min-width: 0;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  img {\n    display: block;\n    margin: 0 auto;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  --thumbs-slide-spacing: 0.8rem;\n  --thumbs-slide-height: 6rem;\n  margin-top: var(--thumbs-slide-spacing);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  margin-left: calc(var(--thumbs-slide-spacing) * -1);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 22%;\n  min-width: 0;\n  padding-left: var(--thumbs-slide-spacing);\n\n  @media (min-width: 576px) {\n    flex: 0 0 15%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 1.8rem;\n  -webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: transparent;\n  touch-action: manipulation;\n  display: inline-flex;\n  text-decoration: none;\n  cursor: pointer;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--detail-high-contrast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: var(--thumbs-slide-height);\n  width: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  width: 40px;\n  height: 40px;\n  top: 45%;\n  transform: translateY(-50%);\n  border: none;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:disabled {\n    opacity: 0.3;\n    cursor: default;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #3bb77e;\n    color: white;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  left: -20px; // \uCE90\uB7EC\uC140 \uBC14\uAE65\uCABD\uC5D0 \uC704\uCE58\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  right: -20px; // \uCE90\uB7EC\uC140 \uBC14\uAE65\uCABD\uC5D0 \uC704\uCE58\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}

var SliderWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-4e4856cd-0"
})(_templateObject());
var SliderViewport = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e4856cd-1"
})(_templateObject1());
var SliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e4856cd-2"
})(_templateObject2());
var Slide = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e4856cd-3"
})(_templateObject3());
var Thumbs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e4856cd-4"
})(_templateObject4());
var ThumbsViewport = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e4856cd-5"
})(_templateObject5());
var ThumbsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e4856cd-6"
})(_templateObject6());
var ThumbsSlide = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e4856cd-7"
})(_templateObject7());
var ThumbsSlideNumber = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4e4856cd-8"
})(_templateObject8());
var DefaultButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4e4856cd-9"
})(_templateObject9());
var PrevButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton).withConfig({
    componentId: "sc-4e4856cd-10"
})(_templateObject10());
var NextButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton).withConfig({
    componentId: "sc-4e4856cd-11"
})(_templateObject11());

;// CONCATENATED MODULE: ./components/customizing/customizingProducts/new/ImageSlider.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var options = {
    loop: true,
    align: "center"
};
var ImageSlider = function(param) {
    var _slides = param.slides, slides = _slides === void 0 ? [] : _slides;
    // 현재 선택된 슬라이드의 인덱스 상태
    var ref = (0,react.useState)(0), selectedIndex = ref[0], setSelectedIndex = ref[1];
    // 메인 슬라이더와 썸네일 슬라이더의 참조 및 API 가져오기
    var ref1 = _slicedToArray((0,embla_carousel_react_esm/* default */.Z)(options), 2), mainRef = ref1[0], mainApi = ref1[1];
    var ref2 = _slicedToArray((0,embla_carousel_react_esm/* default */.Z)({
        containScroll: "keepSnaps",
        dragFree: true
    }), 2), thumbsRef = ref2[0], thumbsApi = ref2[1];
    // 이전/다음 버튼 활성화 상태 관리
    var ref3 = (0,react.useState)(false), prevBtnEnabled = ref3[0], setPrevBtnEnabled = ref3[1];
    var ref4 = (0,react.useState)(false), nextBtnEnabled = ref4[0], setNextBtnEnabled = ref4[1];
    // 이전 슬라이드로 이동하는 함수
    var scrollPrev = (0,react.useCallback)(function() {
        if (!mainApi) return;
        mainApi.scrollPrev();
    }, [
        mainApi
    ]);
    // 다음 슬라이드로 이동하는 함수
    var scrollNext = (0,react.useCallback)(function() {
        if (!mainApi) return;
        mainApi.scrollNext();
    }, [
        mainApi
    ]);
    // 썸네일 클릭 시 해당 슬라이드로 이동하는 함수
    var onThumbClick = (0,react.useCallback)(function(index) {
        if (!mainApi || !thumbsApi) return;
        mainApi.scrollTo(index);
    }, [
        mainApi,
        thumbsApi
    ]);
    // 현재 선택된 슬라이드 상태를 업데이트하는 함수
    var onSelect = (0,react.useCallback)(function() {
        if (!mainApi || !thumbsApi) return;
        setSelectedIndex(mainApi.selectedScrollSnap()); // 현재 선택된 슬라이드 인덱스 설정
        thumbsApi.scrollTo(mainApi.selectedScrollSnap()); // 썸네일도 같은 위치로 스크롤
        setPrevBtnEnabled(mainApi.canScrollPrev()); // 이전 버튼 활성화 여부 설정
        setNextBtnEnabled(mainApi.canScrollNext()); // 다음 버튼 활성화 여부 설정
    }, [
        mainApi,
        thumbsApi
    ]);
    // 슬라이더가 초기화되거나 선택된 슬라이드가 변경될 때 onSelect 실행
    (0,react.useEffect)(function() {
        if (!mainApi) return;
        onSelect();
        mainApi.on("select", onSelect).on("reInit", onSelect);
    }, [
        mainApi,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderViewport, {
                ref: mainRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderContainer, {
                    children: slides.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: item.url,
                                alt: "".concat(index + 1, "_sliderMainImage"),
                                width: 390,
                                height: 390,
                                style: {
                                    width: "100%",
                                    maxWidth: "90%",
                                    height: "auto",
                                    objectFit: "contain",
                                    margin: "0 auto"
                                }
                            })
                        }, "".concat(index, "_sliderMainImage"));
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton, {
                onClick: scrollPrev,
                disabled: !prevBtnEnabled,
                type: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fi-rs-angle-left"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                onClick: scrollNext,
                disabled: !nextBtnEnabled,
                type: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fi-rs-angle-right"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbs, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbsViewport, {
                    ref: thumbsRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbsContainer, {
                        children: slides.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbsSlide, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbsSlideNumber, {
                                    onClick: function() {
                                        return onThumbClick(index);
                                    },
                                    selected: index === selectedIndex,
                                    type: "button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.url,
                                        alt: "".concat(index + 1, "_sliderImage"),
                                        width: 55,
                                        height: 50
                                    })
                                })
                            }, "".concat(index, "_sliderImage"));
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var new_ImageSlider = (ImageSlider);

;// CONCATENATED MODULE: ./components/customizing/customizingProducts/thirdStepEl/input.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function input_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function input_templateObject() {
    var data = input_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n"
    ]);
    input_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function input_templateObject1() {
    var data = input_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 2.5rem;\n  ::placeholder {\n    color: #6c757da5;\n  }\n  :focus {\n    border-color: #3bb77e !important;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n  }\n  @media (max-width: 991px) {\n    width: 100%;\n  }\n"
    ]);
    input_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function input_templateObject2() {
    var data = input_taggedTemplateLiteral([
        "\n  color: #dc3545;\n"
    ]);
    input_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Div = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e2bc8e1-0"
})(input_templateObject());
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-2e2bc8e1-1"
})(input_templateObject1());
var ErrorMsg = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2e2bc8e1-2"
})(input_templateObject2());
var CustomInput = function(param) {
    var title = param.title, code = param.code, size = param.size, onChangeUserInputs = param.onChangeUserInputs, register = param.register, formState = param.formState, cntError = param.cntError, cnt = param.cnt, readOnly = param.readOnly;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Div, {
            children: code === "cnt" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                        type: "number",
                        id: code,
                        name: title,
                        placeholder: title + " \uC785\uB825",
                        className: "form-control",
                        size: size,
                        onChange: onChangeUserInputs,
                        value: cnt ? cnt : "",
                        readOnly: readOnly
                    }),
                    readOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-danger",
                        children: "*\uC544\uB798 \uC870\uAC74\uC5D0 \uB530\uB77C \uC218\uB7C9\uC774 \uC815\uD574\uC9C0\uB294 \uC0C1\uD488\uC785\uB2C8\uB2E4."
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, _objectSpread({
                type: "text",
                id: code,
                name: title,
                placeholder: title + " \uC785\uB825",
                className: "form-control",
                size: size
            }, register(code, {
                required: "\uC785\uB825\uD574\uC8FC\uC138\uC694."
            })))
        })
    });
};
/* harmony default export */ var input = (CustomInput);

;// CONCATENATED MODULE: ./components/customizing/customizingProducts/thirdStepEl/imgSelect.js
function imgSelect_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function imgSelect_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            imgSelect_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function imgSelect_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function imgSelect_templateObject() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  align-items: flex-start;\n\n  @media screen and (max-width: 991px) {\n    grid-template-columns: ",
        ";\n  }\n\n  @media screen and (max-width: 767px) {\n    grid-template-columns: ",
        ";\n  }\n  @media screen and (max-width: 460px) {\n    grid-template-columns: ",
        ";\n  }\n"
    ]);
    imgSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function imgSelect_templateObject1() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  width: 20%;\n  @media (max-width: 991px) {\n    width: 30%;\n  }\n"
    ]);
    imgSelect_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function imgSelect_templateObject2() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  position: relative;\n  :last-of-type {\n    margin-right: 0;\n  }\n  & input {\n    display: none;\n  }\n"
    ]);
    imgSelect_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function imgSelect_templateObject3() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  width: 100%;\n  font-size: 1rem;\n  padding: 10px 10px;\n  overflow: hidden;\n  border: 2px solid #ececec;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: ",
        ";\n  border-color: ",
        ";\n  border-radius: 10px;\n  cursor: pointer;\n  color: #696969;\n  & img {\n    margin: 0 auto;\n  }\n\n  .label_title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    white-space: pre-wrap;\n    max-height: 1rem;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    max-width: 100%;\n  }\n\n  @media screen and (max-width: 767px) {\n    font-size: 14px;\n  }\n  @media (max-width: 575px) {\n    font-size: 12px;\n  }\n"
    ]);
    imgSelect_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function imgSelect_templateObject4() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 10px;\n  width: 100%;\n\n  img {\n    width: auto;\n    max-width: 100%;\n    height: auto;\n    margin-bottom: 10px;\n    border-radius: 5px;\n    object-fit: contain;\n  }\n"
    ]);
    imgSelect_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function imgSelect_templateObject5() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  padding: 8px;\n  background-color: white;\n  border-radius: 5px;\n  width: 100%;\n\n  p {\n    margin-bottom: 5px;\n    font-size: 12px;\n    color: #555;\n    text-align: left;\n  }\n"
    ]);
    imgSelect_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function imgSelect_templateObject6() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  //position: relative;\n  display: inline-block;\n  margin-left: 5px;\n  z-index: 100;\n"
    ]);
    imgSelect_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function imgSelect_templateObject7() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  color: gray;\n  padding: 0 5px;\n  cursor: pointer;\n  border: 1px solid gray;\n  border-radius: 50%;\n  font-size: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n\n  &:hover {\n    color: #3bb77e;\n    border-color: #3bb77e;\n  }\n"
    ]);
    imgSelect_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function imgSelect_templateObject8() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  width: auto;\n  min-width: 200px;\n  max-width: 250px;\n  max-height: 80vh;\n  position: absolute;\n  top: 0%;\n  left: -28%;\n  transform: translateX(-50%);\n  border-radius: 10px;\n  background-color: rgba(255, 255, 255, 0.95);\n  z-index: 101;\n  display: none;\n  padding: 15px;\n  box-shadow: 0px 0px 20px 5px rgba(0, 0, 0, 0.3);\n  overflow-y: auto;\n  text-align: center;\n\n  @media screen and (min-width: 768px) {\n    ",
        ":hover & {\n      display: block;\n    }\n  }\n\n  @media screen and (max-width: 767px) {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 10001;\n    width: 90%;\n    max-width: 350px;\n  }\n"
    ]);
    imgSelect_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function imgSelect_templateObject9() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10000;\n  display: ",
        ";\n"
    ]);
    imgSelect_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function imgSelect_templateObject10() {
    var data = imgSelect_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #555;\n\n  &:hover {\n    color: #3bb77e;\n  }\n"
    ]);
    imgSelect_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




var imgSelect_Div = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adde4e7-0"
})(imgSelect_templateObject(), function(props) {
    return props.less ? "repeat(2, 1fr)" : "repeat(3, 1fr)";
}, function(props) {
    return props.less ? "repeat(2, 1fr)" : "repeat(3, 1fr)";
}, function(props) {
    return props.less ? "repeat(2, 1fr)" : "repeat(3, 1fr)";
});
var Title = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-adde4e7-1"
})(imgSelect_templateObject1());
var CheckBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adde4e7-2"
})(imgSelect_templateObject2());
var CheckBoxLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-adde4e7-3"
})(imgSelect_templateObject3(), function(props) {
    return props.checked ? "#3bb77e" : "black";
}, function(props) {
    return props.checked ? "#3bb77e" : "#ececec";
});
var DetailImageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adde4e7-4"
})(imgSelect_templateObject4());
var DetailMentDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adde4e7-5"
})(imgSelect_templateObject5());
// InfoIconWrapper 수정 - 상대적 위치 지정
var InfoIconWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-adde4e7-6"
})(imgSelect_templateObject6());
// InfoIcon
var InfoIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-adde4e7-7"
})(imgSelect_templateObject7());
var HoverCart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adde4e7-8"
})(imgSelect_templateObject8(), InfoIconWrapper);
// 모달 배경
var ModalOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-adde4e7-9"
})(imgSelect_templateObject9(), function(props) {
    return props.show ? "block" : "none";
});
// 모달 닫기 버튼
var CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-adde4e7-10"
})(imgSelect_templateObject10());
var CustomImgSelect = function(param) {
    var title = param.title, code = param.code, options = param.options, register = param.register, openModal = param.openModal, reset = param.reset, getValues = param.getValues, formState = param.formState, watch = param.watch, detailData = param.detailData, category = param.category;
    var ref4 = (0,react.useState)({}), selectedOption = ref4[0], setSelectedOption = ref4[1];
    var ref1 = (0,react.useState)(JSON.parse(detailData.Opt)), detailOption = ref1[0], setDetailOption = ref1[1];
    var ref2 = (0,react.useState)(false), showModal = ref2[0], setShowModal = ref2[1];
    var ref3 = (0,react.useState)({
        title: "",
        detailMent: [],
        detailImage: []
    }), currentDetailContent = ref3[0], setCurrentDetailContent = ref3[1];
    // 모달 열기 함수
    var handleOpenModal = function(oname, detailMent, detailImage) {
        setCurrentDetailContent({
            title: oname,
            detailMent: detailMent,
            detailImage: detailImage
        });
        setShowModal(true);
    };
    // 모달 닫기 함수
    var handleCloseModal = function() {
        setShowModal(false);
    };
    var onChangeSelectOption = function(el, i) {
        return function(e) {
            setSelectedOption(imgSelect_objectSpread({}, setSelectedOption, imgSelect_defineProperty({}, code, el.okey)));
            reset(imgSelect_objectSpread({}, getValues(), imgSelect_defineProperty({}, code, el.okey)));
        };
    };
    // 옵션의 okey에 해당하는 상세 데이터 찾기 함수
    var findDetailInfo = function(okey) {
        // detailOption 배열에서 해당 okey를 가진 객체 찾기
        var detailItem = detailOption === null || detailOption === void 0 ? void 0 : detailOption.find(function(item) {
            return Object.keys(item)[0] === okey;
        });
        // 해당 항목이 있으면 상세 정보 반환
        if (detailItem && detailItem[okey]) {
            return {
                detailMent: detailItem[okey].detailMent || [],
                detailImage: detailItem[okey].detailImage || []
            };
        }
        // 없으면 빈 배열 반환
        return {
            detailMent: [],
            detailImage: []
        };
    };
    (0,react.useEffect)(function() {
        setSelectedOption({});
        // options 배열이 존재하고 첫 번째 요소가 있을 경우에만 실행
        if (options && options.length > 0) {
            var firstOption = options[0];
            // 폼 리셋 및 첫 번째 옵션 선택
            reset(imgSelect_objectSpread({}, getValues(), imgSelect_defineProperty({}, code, firstOption.okey)));
            // 상태 업데이트
            setSelectedOption(imgSelect_objectSpread({}, selectedOption, imgSelect_defineProperty({}, code, firstOption.okey)));
        }
    }, [
        category,
        options
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(imgSelect_Div, {
                less: options.length < 3,
                children: options.map(function(el, i) {
                    // 각 옵션마다 상세 정보 가져오기
                    var ref = findDetailInfo(el.okey), detailMent = ref.detailMent, detailImage = ref.detailImage;
                    var hasDetails = detailMent.length > 0 || detailImage.length > 0;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckBox, {
                        className: "custome-checkbox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", imgSelect_objectSpread({
                                type: "radio",
                                id: "".concat(code).concat(i),
                                className: "form-check-input",
                                value: el.okey
                            }, register(code))),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckBoxLabel, {
                                htmlFor: "".concat(code).concat(i),
                                value: el.okey,
                                checked: watch(code) === el.okey,
                                style: {
                                    textTransform: "capitalize"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: el.image !== "" ? el.image : "/assets/imgs/shop/cat-1.png",
                                        alt: el.oname
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "label_title",
                                        children: [
                                            el.oname,
                                            hasDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoIconWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {
                                                        onClick: function(e) {
                                                            e.preventDefault();
                                                            if (window.innerWidth <= 767) {
                                                                handleOpenModal(el.oname, detailMent, detailImage);
                                                            }
                                                        },
                                                        children: "?"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCart, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "cart-row",
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                width: "100%"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "cart-tumbnail",
                                                                    style: {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        width: "100%",
                                                                        borderBottom: "0.5px solid #dee2e6"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                                        style: {
                                                                            textAlign: "start",
                                                                            marginTop: "10px",
                                                                            marginBottom: "10px",
                                                                            fontWeight: "bold",
                                                                            fontSize: "16px",
                                                                            width: "100%"
                                                                        },
                                                                        children: [
                                                                            el.oname,
                                                                            " \uC548\uB0B4"
                                                                        ]
                                                                    })
                                                                }),
                                                                detailImage && detailImage.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailImageDiv, {
                                                                    children: detailImage.map(function(imgSrc, idx) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: imgSrc,
                                                                            alt: "\uC0C1\uC138 \uC774\uBBF8\uC9C0 ".concat(idx + 1)
                                                                        }, idx);
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOverlay, {
                show: showModal,
                onClick: handleCloseModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    style: {
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "90%",
                        maxWidth: "350px",
                        maxHeight: "80vh",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        padding: "20px",
                        overflowY: "auto",
                        zIndex: 10002
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                            onClick: handleCloseModal,
                            children: "\xd7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                            style: {
                                textAlign: "start",
                                marginTop: "10px",
                                marginBottom: "10px",
                                fontWeight: "bold",
                                fontSize: "16px",
                                width: "100%",
                                paddingBottom: "10px",
                                borderBottom: "0.5px solid #dee2e6"
                            },
                            children: [
                                currentDetailContent.title,
                                " \uC548\uB0B4"
                            ]
                        }),
                        currentDetailContent.detailImage && currentDetailContent.detailImage.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailImageDiv, {
                            children: currentDetailContent.detailImage.map(function(imgSrc, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: imgSrc,
                                    alt: "\uC0C1\uC138 \uC774\uBBF8\uC9C0 ".concat(idx + 1)
                                }, idx);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var imgSelect = (CustomImgSelect);

;// CONCATENATED MODULE: ./components/customizing/customizingProducts/thirdStepEl/select.js
function select_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function select_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            select_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function select_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function select_templateObject() {
    var data = select_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    select_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function select_templateObject1() {
    var data = select_taggedTemplateLiteral([
        "\n  width: 25%;\n  @media (max-width: 991px) {\n    width: 25%;\n  }\n"
    ]);
    select_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function select_templateObject2() {
    var data = select_taggedTemplateLiteral([
        "\n  width: 45%;\n  height: 2.5rem;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  padding-left: 20px;\n  :focus {\n    border-color: #3bb77e !important;\n    box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n  }\n  @media (max-width: 1024px) {\n    width: 80%;\n  }\n\n  @media (max-width: 991px) {\n    width: 100%;\n  }\n"
    ]);
    select_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function select_templateObject3() {
    var data = select_taggedTemplateLiteral([
        "\n  color: #dc3545;\n"
    ]);
    select_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var select_Div = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61d23b0f-0"
})(select_templateObject());
var select_Title = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-61d23b0f-1"
})(select_templateObject1());
var Select = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    componentId: "sc-61d23b0f-2"
})(select_templateObject2());
var select_ErrorMsg = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-61d23b0f-3"
})(select_templateObject3());
var CustomSelect = function(param) {
    var title = param.title, code = param.code, options = param.options, size = param.size, watch = param.watch, register = param.register, formState = param.formState, getValues = param.getValues, detailData = param.detailData;
    var ref11, ref1;
    var disableCheck = function() {
        if (code === "T0035") {
            var ref, ref2, ref3, ref4, ref5;
            return ((ref5 = (ref4 = (ref3 = (ref2 = detailData === null || detailData === void 0 ? void 0 : (ref = detailData.Row) === null || ref === void 0 ? void 0 : ref.find(function(el) {
                return el.data.find(function(item) {
                    return item.code === "T0034" || item.code === "T0036";
                });
            })) === null || ref2 === void 0 ? void 0 : ref2.data.find(function(el) {
                return el.code === "T0034" || el.code === "T0036";
            })) === null || ref3 === void 0 ? void 0 : ref3.options.filter(function(el) {
                return el.matching === "none";
            })) === null || ref4 === void 0 ? void 0 : ref4.map(function(el) {
                return el.okey;
            })) === null || ref5 === void 0 ? void 0 : ref5.includes(watch("T0034") || watch("T0036"))) || (watch("T0034") || watch("T0036")) == "" || (watch("T0034") || watch("T0036")) == undefined;
        }
        if (code === "T0039") {
            var ref6, ref7, ref8, ref9, ref10;
            return ((ref10 = (ref9 = (ref8 = (ref7 = detailData === null || detailData === void 0 ? void 0 : (ref6 = detailData.Row) === null || ref6 === void 0 ? void 0 : ref6.find(function(el) {
                return el.data.find(function(item) {
                    return item.code === "T0038";
                });
            })) === null || ref7 === void 0 ? void 0 : ref7.data.find(function(el) {
                return el.code === "T0038";
            })) === null || ref8 === void 0 ? void 0 : ref8.options.filter(function(el) {
                return el.matching === "none";
            })) === null || ref9 === void 0 ? void 0 : ref9.map(function(el) {
                return el.okey;
            })) === null || ref10 === void 0 ? void 0 : ref10.includes(watch("T0038"))) || watch("T0038") == "" || watch("T0038") == undefined;
        }
    };
    var matchingFilter = function() {
        var ref16, ref12, ref13, ref14, ref15;
        var matching = (ref15 = (ref13 = (ref12 = detailData === null || detailData === void 0 ? void 0 : (ref16 = detailData.Row) === null || ref16 === void 0 ? void 0 : ref16.find(function(el) {
            var ref;
            return el === null || el === void 0 ? void 0 : (ref = el.data) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                return code === "T0035" ? item.code === "T0034" || item.code === "T0036" : item.code === "T0038";
            });
        })) === null || ref12 === void 0 ? void 0 : ref12.data.find(function(el) {
            return el.code === "T0034" || el.code === "T0036" || el.code === "T0038";
        })) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.options) === null || ref14 === void 0 ? void 0 : ref14.find(function(option) {
            return option.okey == watch("T0034") || option.okey == watch("T0036") || option.okey == watch("T0038");
        })) === null || ref15 === void 0 ? void 0 : ref15.matching;
        if (code === "T0035" || code === "T0039") {
            return options === null || options === void 0 ? void 0 : options.filter(function(option) {
                return option.matching.split(",").includes(matching);
            });
        } else {
            return options;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_Div, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, select_objectSpread({
                    id: code,
                    name: title,
                    className: "form-select",
                    defaultValue: "",
                    disabled: disableCheck()
                }, register(code), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                            value: "",
                            disabled: true,
                            children: [
                                disableCheck() ? "\uC9C0\uC885 \uC120\uD0DD \uD6C4" : title,
                                " \uC120\uD0DD"
                            ]
                        }),
                        (ref11 = matchingFilter()) === null || ref11 === void 0 ? void 0 : ref11.map(function(el, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: el.okey,
                                children: el.oname
                            }, i);
                        })
                    ]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(select_ErrorMsg, {
                    children: (ref1 = formState === null || formState === void 0 ? void 0 : formState.errors[code]) === null || ref1 === void 0 ? void 0 : ref1.message
                })
            ]
        })
    });
};
/* harmony default export */ var thirdStepEl_select = (CustomSelect);

;// CONCATENATED MODULE: ./components/customizing/customizingProducts/thirdStepEl/print.js
function print_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return print_arrayLikeToArray(arr);
}
function print_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function print_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            print_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function print_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || print_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function print_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return print_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return print_arrayLikeToArray(o, minLen);
}
function print_templateObject() {
    var data = print_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    print_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function print_templateObject1() {
    var data = print_taggedTemplateLiteral([
        "\n  width: 25%;\n  display: flex;\n  align-items: center;\n"
    ]);
    print_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function print_templateObject2() {
    var data = print_taggedTemplateLiteral([
        ""
    ]);
    print_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function print_templateObject3() {
    var data = print_taggedTemplateLiteral([
        "\n  width: 75%;\n  display: flex;\n  align-items: center;\n  & input {\n    display: none;\n  }\n"
    ]);
    print_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function print_templateObject4() {
    var data = print_taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  padding: 10px 20px;\n  overflow: hidden;\n  border: 1px solid #ececec;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-color: ",
        ";\n  :last-of-type {\n    border-right: 1px solid #ececec;\n  }\n  cursor: pointer;\n"
    ]);
    print_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var print_Div = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f181e958-0"
})(print_templateObject());
var CheckBoxDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f181e958-1"
})(print_templateObject1());
var print_Title = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-f181e958-2"
})(print_templateObject2());
var SizeCheck = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f181e958-3"
})(print_templateObject3());
var SizeLable = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-f181e958-4"
})(print_templateObject4(), function(props) {
    return props.checked ? "#3bb77e" : "#fff";
}, function(props) {
    return props.checked ? "#fff" : "6c757da5";
}, function(props) {
    return props.checked ? "#3bb77e" : "#ececec";
});
var CustomPrint = function(param) {
    var title = param.title, code = param.code, options = param.options, openModal = param.openModal, register = param.register, reset = param.reset, getValues = param.getValues, formState = param.formState, watch = param.watch, detailData = param.detailData;
    var ref2 = (0,react.useState)(new Array(options.length).fill("")), checkedSide = ref2[0], setCheckedSide = ref2[1];
    var ref1 = (0,react.useState)(new Array(options.length).fill("")), selectedSize = ref1[0], setSelectedSize = ref1[1];
    var onChangeCheckbox = function(i) {
        return function(e) {
            var tempArr = _toConsumableArray(checkedSide);
            tempArr[i] = e.target.checked;
            setCheckedSide(tempArr);
            selectedSize[i] = "";
            if (!e.target.checked) {
                var tempArr2 = getValues(code) == undefined ? [] : _toConsumableArray(getValues(code));
                tempArr2[i] = undefined;
                reset(print_objectSpread({}, getValues(), print_defineProperty({}, code, _toConsumableArray(tempArr2.filter(function(el) {
                    return el !== undefined;
                })))));
            }
        };
    };
    var onChangeCheckSize = function(el1, i) {
        return function(e) {
            var tempArr = _toConsumableArray(selectedSize);
            tempArr[i] = e.target.value;
            setSelectedSize(tempArr);
            if (checkedSide[i]) {
                var tempArr2 = getValues(code) == undefined ? [] : _toConsumableArray(getValues(code));
                tempArr2[i] = {
                    key: el1.okey,
                    value: e.target.value
                };
                reset(print_objectSpread({}, getValues(), print_defineProperty({}, code, _toConsumableArray(tempArr2.filter(function(el) {
                    return el !== undefined;
                })))));
            }
        };
    };
    var printCheck = function() {
        var ref;
        return watch("T0006") === ((ref = detailData.Row.find(function(el) {
            return el.data.find(function(item) {
                return item.code === "T0006";
            });
        }).data.find(function(el) {
            return el.code === "T0006";
        }).options.find(function(el) {
            return el.oname === "\uBB34\uC778\uC1C4";
        })) === null || ref === void 0 ? void 0 : ref.okey) || watch("T0006") === "" || getValues("T0006") === undefined;
    };
    (0,react.useEffect)(function() {
        if (printCheck()) {
            setSelectedSize(new Array(options.length).fill(""));
            setCheckedSide(new Array(options.length).fill(""));
        }
    }, [
        printCheck()
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: printCheck() !== true && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: options.map(function(el, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(print_Div, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckBoxDiv, {
                            className: "custome-checkbox",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    id: "".concat(code).concat(i),
                                    className: "form-check-input",
                                    onChange: onChangeCheckbox(i),
                                    disabled: printCheck()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "form-check-label",
                                    htmlFor: "".concat(code).concat(i),
                                    style: {
                                        textTransform: "capitalize"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(print_Title, {
                                    children: el.oname
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SizeCheck, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    id: "large".concat(i),
                                    name: "printLarge",
                                    className: "form-check-input",
                                    value: "large",
                                    checked: selectedSize[i] && selectedSize[i] === "large",
                                    onChange: onChangeCheckSize(el, i),
                                    disabled: !checkedSide[i]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeLable, {
                                    selectedSize: selectedSize,
                                    className: "form-check-label",
                                    htmlFor: "large".concat(i),
                                    value: "large",
                                    checked: checkedSide[i] && selectedSize[i] === "large",
                                    style: {
                                        textTransform: "capitalize"
                                    },
                                    children: "\uB300"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    id: "medium".concat(i),
                                    name: title,
                                    className: "form-check-input",
                                    value: "medium",
                                    checked: selectedSize[i] && selectedSize[i] === "medium",
                                    onChange: onChangeCheckSize(el, i),
                                    disabled: !checkedSide[i]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeLable, {
                                    selectedSize: selectedSize,
                                    value: "medium",
                                    className: "form-check-label",
                                    htmlFor: "medium".concat(i),
                                    checked: checkedSide[i] && selectedSize[i] === "medium",
                                    style: {
                                        textTransform: "capitalize"
                                    },
                                    children: "\uC911"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    id: "small".concat(i),
                                    name: title,
                                    className: "form-check-input",
                                    value: "small",
                                    checked: selectedSize[i] && selectedSize[i] === "small",
                                    onChange: onChangeCheckSize(el, i),
                                    disabled: !checkedSide[i]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeLable, {
                                    selectedSize: selectedSize,
                                    className: "form-check-label",
                                    htmlFor: "small".concat(i),
                                    value: "small",
                                    checked: checkedSide[i] && selectedSize[i] === "small",
                                    style: {
                                        textTransform: "capitalize"
                                    },
                                    children: "\uC18C"
                                })
                            ]
                        })
                    ]
                }, i);
            })
        })
    });
};
/* harmony default export */ var print = (CustomPrint);

// EXTERNAL MODULE: ./api/downloads.js
var downloads = __webpack_require__(15187);
// EXTERNAL MODULE: ./common/files.js
var files = __webpack_require__(10289);
;// CONCATENATED MODULE: ./components/customizing/customizingProducts/thirdStepEl/radio.js
function radio_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function radio_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            radio_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function radio_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function radio_templateObject() {
    var data = radio_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n  .title {\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    & h6 {\n      @media screen and (max-width: 991px) {\n        font-size: 14px !important;\n      }\n      @media screen and (max-width: 575px) {\n        font-size: 12px !important;\n        white-space: nowrap;\n      }\n    }\n  }\n"
    ]);
    radio_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function radio_templateObject1() {
    var data = radio_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #ececec;\n  justify-content: center;\n  align-items: center;\n  > div {\n    width: 100%;\n  }\n  & label {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 7px;\n    margin: 0px;\n    cursor: pointer;\n    @media screen and (max-width: 460px) {\n      font-size: 12px !important;\n      padding: 5px;\n    }\n  }\n\n  & input {\n    display: none;\n  }\n"
    ]);
    radio_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function radio_templateObject2() {
    var data = radio_taggedTemplateLiteral([
        ""
    ]);
    radio_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function radio_templateObject3() {
    var data = radio_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  border-bottom: ",
        ";\n"
    ]);
    radio_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function radio_templateObject4() {
    var data = radio_taggedTemplateLiteral([
        "\n  color: #dc3545;\n"
    ]);
    radio_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var radio_Div = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66615192-0"
})(radio_templateObject());
var RadioWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66615192-1"
})(radio_templateObject1());
var Radio = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-66615192-2"
})(radio_templateObject2());
var Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-66615192-3"
})(radio_templateObject3(), function(props) {
    return props.checked ? "#3bb77e" : "#fff";
}, function(props) {
    return props.checked ? "#fff" : "#7e7e7e";
}, function(props) {
    return props.i == 0 ? "1px solid #ececec" : "none";
});
var radio_ErrorMsg = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-66615192-4"
})(radio_templateObject4());
var CustomRadio = function(param) {
    var title = param.title, code = param.code, options = param.options, openModal = param.openModal, register = param.register, formState = param.formState, reset = param.reset, getValues = param.getValues, watch = param.watch, detailData = param.detailData;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(radio_Div, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "title",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        children: title.split("_")[1]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioWrapper, {
                    children: options === null || options === void 0 ? void 0 : options.map(function(option, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                    htmlFor: option.okey,
                                    i: i,
                                    checked: watch(code) === option.okey ? true : false,
                                    children: option.oname
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, radio_objectSpread({
                                    type: "radio",
                                    name: title,
                                    id: option.okey,
                                    value: option.okey
                                }, register(code)))
                            ]
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_ErrorMsg, {
                    children: (ref = formState === null || formState === void 0 ? void 0 : formState.errors[code]) === null || ref === void 0 ? void 0 : ref.message
                })
            ]
        })
    });
};
/* harmony default export */ var thirdStepEl_radio = (CustomRadio);

;// CONCATENATED MODULE: ./components/customizing/customizingProducts/thirdStepEl/text.js
function text_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function text_templateObject() {
    var data = text_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    text_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function text_templateObject1() {
    var data = text_taggedTemplateLiteral([
        "\n  color: #dc3545;\n  word-break: keep-all;\n"
    ]);
    text_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function text_templateObject2() {
    var data = text_taggedTemplateLiteral([
        "\n  color: #dc3545;\n"
    ]);
    text_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var text_Div = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45de6591-0"
})(text_templateObject());
var Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45de6591-1"
})(text_templateObject1());
var text_ErrorMsg = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-45de6591-2"
})(text_templateObject2());
var CustomText = function(param) {
    var title = param.title, code = param.code, options = param.options, openModal = param.openModal, register = param.register, formState = param.formState, reset = param.reset, getValues = param.getValues, watch = param.watch, detailData = param.detailData;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_Div, {
            children: [
                options === null || options === void 0 ? void 0 : options.map(function(option, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        children: option.oname
                    }, i);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_ErrorMsg, {
                    children: (ref = formState === null || formState === void 0 ? void 0 : formState.errors[code]) === null || ref === void 0 ? void 0 : ref.message
                })
            ]
        })
    });
};
/* harmony default export */ var thirdStepEl_text = (CustomText);

;// CONCATENATED MODULE: ./components/customizing/customizingProducts/new/ProductsDetail.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductsDetail_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductsDetail_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductsDetail_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var ProductDetail = function(param) {
    var detailData = param.detailData, category = param.category, onChangeUserInputs = param.onChangeUserInputs, directConfirm = param.directConfirm, isUser = param.isUser, cnt = param.cnt, cntError = param.cntError, setIntroductions = param.setIntroductions, modalContents = param.modalContents, setModalContents = param.setModalContents;
    var ref6, ref1;
    var ref2 = (0,index_esm/* useFormContext */.Gc)(), register = ref2.register, formState = ref2.formState, watch = ref2.watch, reset = ref2.reset, getValues = ref2.getValues;
    var openModal = function(i, el) {
        return function() {
            setModalContents(ProductsDetail_objectSpread({}, modalContents, {
                show: true,
                image: el.image,
                title: el.title
            }));
        };
    };
    // row Type Checking
    var typeChecking = function(data) {
        if (data.type === "I") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                title: data.name,
                code: data.code,
                onChangeUserInputs: onChangeUserInputs,
                register: register,
                formState: formState,
                cntError: cntError,
                cnt: cnt,
                watch: watch
            });
        }
        if (data.type === "S") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(thirdStepEl_select, {
                title: data.name,
                code: data.code,
                options: data.options,
                register: register,
                formState: formState,
                watch: watch,
                getValues: getValues,
                detailData: detailData
            });
        }
        if (data.type === "M") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(print, {
                title: data.name,
                code: data.code,
                options: data.options,
                openModal: openModal,
                register: register,
                reset: reset,
                formState: formState,
                watch: watch,
                getValues: getValues,
                detailData: detailData
            });
        }
        if (data.type === "D") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(imgSelect, {
                title: data.name,
                code: data.code,
                options: data.options,
                openModal: openModal,
                register: register,
                formState: formState,
                reset: reset,
                getValues: getValues,
                watch: watch,
                detailData: detailData,
                category: category
            });
        }
        if (data.type === "R") {
            if (watch(data.code) == undefined) {
                setTimeout(function() {
                    reset(ProductsDetail_objectSpread({}, watch(), ProductsDetail_defineProperty({}, data.code, data.options[1].okey)));
                }, 200);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(thirdStepEl_radio, {
                title: data.name,
                code: data.code,
                options: data.options,
                openModal: openModal,
                register: register,
                formState: formState,
                reset: reset,
                getValues: getValues,
                watch: watch,
                detailData: detailData
            });
        }
        if (data.type === "T") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(thirdStepEl_text, {
                title: data.name,
                code: data.code,
                options: data.options,
                openModal: openModal,
                register: register,
                formState: formState,
                reset: reset,
                getValues: getValues,
                watch: watch,
                detailData: detailData
            });
        }
    };
    // 칼선 다운로드
    var printDownload = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(code) {
            var body, res, ref, ref3, url, ref4, ref5;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.next = 3;
                        return (0,downloads/* downloadsAPI */.P)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            if (code === "M0039") {
                                ;
                                url = res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : (ref3 = ref.Data) === null || ref3 === void 0 ? void 0 : ref3.packaging.find(function(el) {
                                    return el.code === "F1084";
                                }).url;
                                (0,files/* fileDownloadHelper */.MB)(url);
                            }
                        } else {
                            ;
                            failAlert((res === null || res === void 0 ? void 0 : (ref4 = res.Data) === null || ref4 === void 0 ? void 0 : ref4.Msg) || res);
                            console.error((ref5 = res.Data) === null || ref5 === void 0 ? void 0 : ref5.Msg);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function printDownload(code) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchIntroductions = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref7, ref8;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.next = 3;
                        return (0,downloads/* downloadsAPI */.P)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            setIntroductions(res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : (ref7 = ref.Data) === null || ref7 === void 0 ? void 0 : ref7.introduction);
                        } else {
                            ;
                            setIntroductions([]);
                            console.error((ref8 = res.Data) === null || ref8 === void 0 ? void 0 : ref8.Msg);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchIntroductions() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if ((category === null || category === void 0 ? void 0 : category.code) === "M0039") {
            fetchIntroductions();
        }
        reset({});
    }, [
        detailData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* ContentWrapper */.vs, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* ContentBox */.Y_, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* ContentBoxTitle */.oW, {
                            children: "\uC81C\uC791 \uC218\uB7C9"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cnt_box",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                                title: "\uC218\uB7C9",
                                code: "cnt",
                                onChangeUserInputs: onChangeUserInputs,
                                register: register,
                                cntError: cntError,
                                cnt: cnt,
                                readOnly: (category === null || category === void 0 ? void 0 : category.code) === "M0039"
                            })
                        })
                    ]
                }),
                ((ref6 = detailData.Row) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && ((ref1 = detailData.Row) === null || ref1 === void 0 ? void 0 : ref1.map(function(el1, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Customizing_styles/* ContentBox */.Y_, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* ContentBoxTitle */.oW, {
                                children: [
                                    el1.title,
                                    el1.image && el1.image !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "size_info",
                                        onClick: openModal(i, el1),
                                        children: "\uC0C1\uC138\uAC00\uC774\uB4DC \uBCF4\uAE30"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* BoxItem */.EC, {
                                row: el1.data.length > 0 && el1.data.map(function(el) {
                                    return el.type !== "I" && el.type !== "R";
                                }).includes(false),
                                grid: !el1.data.map(function(el) {
                                    return el.type == "R";
                                }).includes(false),
                                className: !el1.data.map(function(el) {
                                    return el.type == "R";
                                }).includes(false) && "radios",
                                children: el1.data.map(function(data, dataIndex) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            width: "100%"
                                        },
                                        children: [
                                            data.code === "T0006" && (category === null || category === void 0 ? void 0 : category.code) === "M0039" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "print_download",
                                                onClick: function() {
                                                    return printDownload(category === null || category === void 0 ? void 0 : category.code);
                                                },
                                                children: "\uB3C4\uC548 \uB2E4\uC6B4\uB85C\uB4DC"
                                            }),
                                            typeChecking(data)
                                        ]
                                    }, dataIndex);
                                })
                            })
                        ]
                    }, i);
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* BtnWrapper */.Bo, {
                    children: [
                        isUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-md btn-secondary",
                            type: "submit",
                            children: "\uACAC\uC801 \uBC14\uAD6C\uB2C8\uC5D0 \uB2F4\uAE30"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-md",
                            onClick: directConfirm,
                            type: "button",
                            children: "\uBC14\uB85C \uACAC\uC801 \uC694\uCCAD"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ProductsDetail = (ProductDetail);

// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 91 modules
var swiper_esm = __webpack_require__(8701);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
;// CONCATENATED MODULE: ./components/customizing/customizingProducts/CustomizingModal.js
function CustomizingModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CustomizingModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CustomizingModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CustomizingModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CustomizingModal_templateObject() {
    var data = CustomizingModal_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000002;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .modal-section {\n    background-color: white;\n    border-radius: 10px;\n    overflow: hidden !important;\n    border: none;\n    overflow-y: auto;\n    width: auto;\n  }\n\n  .modal-header {\n    max-width: 100%;\n    padding: 15px;\n    font-size: 1rem;\n    font-weight: 500;\n    color: black;\n    display: flex;\n    justify-content: space-between;\n    .title-wrapper {\n    }\n    .btn-wrapper {\n      & i {\n        font-size: 1.5rem;\n        color: black;\n        cursor: pointer;\n        :hover {\n          color: #3bb77e;\n        }\n      }\n    }\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n  }\n\n  .modal-content {\n    padding: 20px;\n    border: none;\n    position: relative;\n    margin: 0 auto;\n    width: 700px;\n    height: auto;\n    display: flex;\n    justify-content: center;\n    @media (max-width: 767px) {\n      width: 100%;\n    }\n  }\n  .swiper-wrapper {\n    width: 645px !important;\n    max-width: 100%;\n    display: flex;\n    padding-bottom: 15px;\n    @media (max-width: 767px) {\n      width: 100% !important;\n    }\n  }\n  .swiper-slide {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: auto;\n    max-height: 638px;\n    overflow-y: auto;\n    width: 645px !important;\n    overflow-y: auto;\n    padding: 0px 50px;\n    @media (max-width: 767px) {\n      width: 100% !important;\n      height: auto !important;\n    }\n  }\n\n  .img_box {\n    width: auto;\n    display: flex;\n    justify-content: center;\n    & img {\n      /* max-height: 100%; */\n    }\n  }\n\n  .swiper-pagination {\n    position: absolute;\n    bottom: 0;\n    z-index: 100000;\n    display: flex;\n    justify-content: center;\n  }\n\n  .swiper-pagination-bullet {\n    display: flex;\n    border-radius: 50%;\n    margin-right: 5px;\n    background-color: #ececec;\n    width: 13px !important;\n    height: 13px !important;\n    @media (max-width: 767px) {\n      width: 13px !important;\n      height: 13px !important;\n    }\n    :last-of-type {\n      margin-right: 0px;\n    }\n  }\n"
    ]);
    CustomizingModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CustomizingModal_templateObject1() {
    var data = CustomizingModal_taggedTemplateLiteral([
        "\n  display: flex;\n  position: absolute;\n  width: 100% !important;\n  top: 45%;\n  left: 0;\n  @media (max-width: 767px) {\n    top: 45%;\n    & span {\n      width: 30px !important;\n      height: 30px !important;\n      display: flex !important;\n      justify-content: center !important;\n      align-items: center !important;\n    }\n    & i {\n      margin: 0px !important;\n    }\n  }\n"
    ]);
    CustomizingModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Autoplay */.pt,
    swiper_esm/* Pagination */.tl
]);
var ModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14c7d8f7-0"
})(CustomizingModal_templateObject());
var SlideArrows = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14c7d8f7-1"
})(CustomizingModal_templateObject1());
var CustomizingModal = function(param) {
    var modalContents = param.modalContents, setModalContents = param.setModalContents;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") {
            closeModal();
        }
    };
    var closeModal = function() {
        setModalContents(CustomizingModal_objectSpread({}, modalContents, {
            show: false
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "title-wrapper",
                                children: [
                                    modalContents.title,
                                    " \uC548\uB0B4"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "btn-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fi-rs-circle-cross",
                                    onClick: closeModal
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                pagination: true,
                                navigation: {
                                    prevEl: ".custom_prev_if1",
                                    nextEl: ".custom_next_if1"
                                },
                                slidesPerView: 1,
                                children: modalContents.image.split(",").length >= 1 && modalContents.image.split(",").filter(function(el) {
                                    return el !== "";
                                }).map(function(el, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "img_box",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: el
                                            })
                                        })
                                    }, i);
                                })
                            }),
                            modalContents.image.split(",").length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlideArrows, {
                                className: "slider-arrow slider-arrow-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "slider-btn slider-prev slick-arrow custom_prev_if1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-arrow-small-left"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "slider-btn slider-next slick-arrow custom_next_if1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-arrow-small-right"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var customizingProducts_CustomizingModal = (CustomizingModal);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
;// CONCATENATED MODULE: ./hook/customizing/customizing-products/useGalleryListQuery.js
function useGalleryListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useGalleryListQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useGalleryListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useGalleryListQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




// 제작사례 & 포장재리뷰 불러오기
var useGetGalleryList = function() {
    return (0,useQuery/* useQuery */.a)({
        queryKey: queryKeys/* QUERY_KEYS.CUSTOMIZING.GALLERY.INDEX */.U.CUSTOMIZING.GALLERY.INDEX,
        queryFn: useGalleryListQuery_asyncToGenerator(runtime_default().mark(function _callee() {
            var res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,packaging/* PackagingApi */.Ri)({
                            modes: "GalleryListSet"
                        });
                    case 2:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", ((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Data) || []);
                    case 8:
                        {
                            console.error(res === null || res === void 0 ? void 0 : res.message); // 에러 처리
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        // staleTime: 1000 * 60 * 5, // 5분 동안 데이터 유지
        retry: 1
    });
};

;// CONCATENATED MODULE: ./hook/customizing/customizing-products/useCustomBasketQuery.js
function useCustomBasketQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useCustomBasketQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useCustomBasketQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useCustomBasketQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




// 장바구니 리스트 불러오기
var useGetCustomBasketList = function() {
    return (0,useQuery/* useQuery */.a)({
        queryKey: queryKeys/* QUERY_KEYS.CUSTOMIZING.BASKETS.INDEX */.U.CUSTOMIZING.BASKETS.INDEX,
        queryFn: useCustomBasketQuery_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,packagingBasket/* PackagingListSet */.tP)({
                            modes: "ListSet"
                        });
                    case 2:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", res.Data || []);
                    case 7:
                        return _ctx.abrupt("return", []);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        retry: 1
    });
};

// EXTERNAL MODULE: ./api/makeCategorys.js
var makeCategorys = __webpack_require__(47597);
;// CONCATENATED MODULE: ./hook/customizing/customizing-products/useCategoryDetailQuery.js
function useCategoryDetailQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useCategoryDetailQuery_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useCategoryDetailQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useCategoryDetailQuery_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




// 카테고리 상세내용 불러오기
var useGetCategoryDetailList = function(code, setCateLoading) {
    return (0,useQuery/* useQuery */.a)({
        queryKey: queryKeys/* QUERY_KEYS.CUSTOMIZING.CATEGORY.DETAIL */.U.CUSTOMIZING.CATEGORY.DETAIL(code),
        queryFn: useCategoryDetailQuery_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (code) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", null);
                    case 2:
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,makeCategorys/* CategoryListSet */.w)({
                            modes: "ItemDetail",
                            code: code
                        });
                    case 5:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", res.Data || []);
                    case 10:
                        {
                            console.error(res === null || res === void 0 ? void 0 : res.message); // 에러 처리
                        }
                    case 11:
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error(_ctx.t0); // 네트워크 에러 등
                    case 16:
                        _ctx.prev = 16;
                        setCateLoading(false); // API 호출 후 반드시 로딩 상태 종료
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    13,
                    16,
                    19
                ]
            ]);
        })),
        enabled: !!code,
        staleTime: 1000 * 60 * 5,
        retry: 1
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/customizing/customizingProducts/PortfolioSlider.js
var PortfolioSlider = __webpack_require__(42682);
// EXTERNAL MODULE: ./common/splicePrice.js
var splicePrice = __webpack_require__(8025);
;// CONCATENATED MODULE: ./components/customizing/customizingProducts/new/CustomizingHeader.js






var CustomizingHeader = function(param) {
    var isUser = param.isUser, dummyList = param.dummyList, basketData = param.basketData, category = param.category, gallery = param.gallery, deleteBasketItem = param.deleteBasketItem;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            router.query.code && /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* HeaderTitle */.Gh, {
                style: {
                    marginTop: "70px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "\uC81C\uC791\uD560",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: (dummyList === null || dummyList === void 0 ? void 0 : dummyList.make_category) && category && (dummyList === null || dummyList === void 0 ? void 0 : dummyList.make_category[category === null || category === void 0 ? void 0 : category.code])
                        }),
                        "\uC758 \uC138\uBD80\uD56D\uBAA9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* CustomMobileTitle */.Ce, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: "\uC138\uBD80\uD56D\uBAA9 \uC785\uB825"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* CustomCartWrapper */.xz, {
                new: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/customizing/customizing-products/?type=".concat(router.query.type ? router.query.type : "S"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "".concat(TYPE[router.query.type ? router.query.type : "S"], " ")
                                })
                            }),
                            (dummyList === null || dummyList === void 0 ? void 0 : dummyList.make_category) && router.query.first && (dummyList === null || dummyList === void 0 ? void 0 : dummyList.make_category[(ref = router.query) === null || ref === void 0 ? void 0 : ref.first]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "> ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/customizing/customizing-products/?type=".concat(router.query.type ? router.query.type : "S", "&first=").concat(router.query.first),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "".concat(dummyList === null || dummyList === void 0 ? void 0 : dummyList.make_category[(ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.first], " ")
                                        })
                                    })
                                ]
                            }),
                            (dummyList === null || dummyList === void 0 ? void 0 : dummyList.make_category) && router.query.code && (dummyList === null || dummyList === void 0 ? void 0 : dummyList.make_category[router.query.code]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "> ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/customizing/customizing-products/new/?type=".concat(router.query.type ? router.query.type : "S", "&first=").concat(router.query.first, "&code=").concat(router.query.code),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "".concat(dummyList === null || dummyList === void 0 ? void 0 : dummyList.make_category[router.query.code])
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cart",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: isUser ? " \uD604\uC7AC \uACAC\uC801 \uBC14\uAD6C\uB2C8\uC5D0 ".concat((basketData === null || basketData === void 0 ? void 0 : basketData.Count) || 0, "\uAC1C\uC758 \uACAC\uC801\uC774 \uB2F4\uACA8\uC788\uC2B5\uB2C8\uB2E4.") : "\uB85C\uADF8\uC778 \uC2DC \uC774\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "icon",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-shopping-bag"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "bag-count",
                                        children: (basketData === null || basketData === void 0 ? void 0 : basketData.Count) || 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hover-cart",
                                children: [
                                    basketData === null || basketData === void 0 ? void 0 : (ref2 = basketData.Rows) === null || ref2 === void 0 ? void 0 : ref2.map(function(el, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cart-row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "cart-tumbnail",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: el.images && el.images[0] ? el.images[0] : el.image
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            children: el.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "cart-info",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "info-box",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "\uC218\uB7C9 :"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: (0,splicePrice/* priceComma */.a)(el.cnt)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "\uB2E8\uAC00 :"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: el.price === "0" ? "24\uC2DC\uAC04 \uC774\uB0B4 \uACAC\uC801" : (0,splicePrice/* priceComma */.a)(el.price) + "\uC6D0"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "\uD569\uACC4 :"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: el.price === "0" ? "24\uC2DC\uAC04 \uC774\uB0B4 \uACAC\uC801" : (0,splicePrice/* priceComma */.a)(Number(el.cnt) * Number(el.price)) + "\uC6D0"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "btn-box",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn btn-sm btn-danger",
                                                                onClick: function() {
                                                                    return deleteBasketItem(el.id);
                                                                },
                                                                children: "\uC0AD\uC81C"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, i);
                                    }),
                                    !isUser ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex flex-column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    color: "#212529",
                                                    textAlign: "center",
                                                    marginBottom: "10px"
                                                },
                                                children: "\uB85C\uADF8\uC778\uC774 \uD544\uC694\uD55C \uAE30\uB2A5\uC785\uB2C8\uB2E4."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/login",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "btn btn-sm",
                                                    children: "\uB85C\uADF8\uC778"
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-btn",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/customizing/customizing-cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "btn btn-sm",
                                                children: "\uACAC\uC801 \uBC14\uAD6C\uB2C8\uB85C \uC774\uB3D9"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !router.query.code && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioSlider/* default */.Z, {
                    gallery: gallery
                })
            })
        ]
    });
};
/* harmony default export */ var new_CustomizingHeader = (CustomizingHeader);
var TYPE = {
    S: "\uD3EC\uC7A5\uC7AC \uBA3C\uC800 \uC120\uD0DD\uD558\uAE30",
    T: "\uD3EC\uC7A5\uD560 \uC81C\uD488\uC744 \uBA3C\uC800 \uC120\uD0DD\uD558\uAE30"
};

// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./pages/customizing/customizing-products/new/index.js
function new_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function new_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                new_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                new_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function new_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function new_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            new_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




























var CustomizingDetailPage = function(param) {
    var _$openConfirmModal = param.openConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$closeConfirmModal = param.closeConfirmModal, dummyList = param.dummyList;
    var ref18, ref1, ref2, ref3;
    var cateRef = (0,react.useRef)();
    var router = (0,next_router.useRouter)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref4 = (0,react.useState)(), category = ref4[0], setCategory = ref4[1];
    // 입력 정보
    var ref5 = (0,react.useState)(""), cnt = ref5[0], setCnt = ref5[1];
    var ref6 = (0,react.useState)("\uC218\uB7C9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."), cntError = ref6[0], setCntError = ref6[1];
    // 유저 여부
    var ref7 = (0,react.useState)(false), isUser = ref7[0], setIsUser = ref7[1];
    // 카테고리 불러오기 loading
    var ref8 = (0,react.useState)(false), cateLoading = ref8[0], setCateLoading = ref8[1];
    // 제작사례 & 포장재리뷰 불러오기
    var ref9 = useGetGalleryList(), galleryData = ref9.data;
    // 장바구니 리스트 불러오기
    var ref10 = useGetCustomBasketList(), basketData = ref10.data, refetchBasket = ref10.refetch;
    // 카테고리 상세내용 불러오기
    var ref11 = useGetCategoryDetailList(router.query.code, setCateLoading), detailData = ref11.data;
    // 바로 견적 요청
    var directConfirm = function() {
        var _ref = new_asyncToGenerator(runtime_default().mark(function _callee() {
            var temp, tempArr, body, res, ref, ref14, ref15, ref16, ref17;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(cnt === "")) {
                            _ctx.next = 5;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC218\uB7C9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        setCntError("\uC218\uB7C9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        setTimeout(function() {
                            window.scrollTo({
                                behavior: "smooth",
                                left: 0,
                                top: window.innerWidth > 991 ? cateRef.current.scrollHeight + 100 : cateRef.current.scrollHeight
                            });
                        }, [
                            200
                        ]);
                        return _ctx.abrupt("return");
                    case 5:
                        if (!(Object.values(methods.getValues()).includes("") || Object.values(methods.getValues()).includes(null) || Object.values(methods.getValues()).includes(undefined))) {
                            _ctx.next = 9;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uB0B4\uC6A9\uC744 \uC804\uBD80 \uCC44\uC6CC\uC8FC\uC138\uC694");
                        setTimeout(function() {
                            window.scrollTo({
                                behavior: "smooth",
                                left: 0,
                                top: window.innerWidth > 991 ? cateRef.current.scrollHeight + 100 : cateRef.current.scrollHeight
                            });
                        }, [
                            200
                        ]);
                        return _ctx.abrupt("return");
                    case 9:
                        temp = Object.keys(methods.getValues());
                        tempArr = temp.map(function(el) {
                            return {
                                code: el,
                                value: methods.getValues()[el]
                            };
                        });
                        body = {
                            modes: "ItemCheck",
                            dcode: category.code,
                            cnt: cnt,
                            items: JSON.stringify(tempArr)
                        };
                        _ctx.next = 14;
                        return (0,packaging/* ItemCheckPackaging */.hU)(body);
                    case 14:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            sessionStorage.setItem("directBasket", JSON.stringify([
                                {
                                    cnt: cnt,
                                    image: detailData.Image,
                                    name: dummyList === null || dummyList === void 0 ? void 0 : dummyList.make_category[category.code],
                                    code: category.code,
                                    options: (ref = res.Data) === null || ref === void 0 ? void 0 : ref.Row,
                                    unit: (ref14 = res.Data) === null || ref14 === void 0 ? void 0 : ref14.Unit,
                                    items: JSON.stringify(tempArr)
                                }, 
                            ]));
                            router.push({
                                pathname: "/customizing/customizing-cart",
                                query: {
                                    type: "direct"
                                }
                            });
                        }
                        if (res.Code === "8888") {
                            ;
                            setCnt(res.Data.Cnt);
                            (0,common_alert/* failAlert */.qh)(((ref15 = res.Data) === null || ref15 === void 0 ? void 0 : ref15.Msg) ? res.Data.Msg : "\uC81C\uC791\uAC00\uB2A5\uD55C \uC218\uB7C9\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.");
                        }
                        if (res.Code === "9999") {
                            ;
                            (0,common_alert/* failAlert */.qh)(((ref16 = res.Data) === null || ref16 === void 0 ? void 0 : ref16.Msg) ? (ref17 = res.Data) === null || ref17 === void 0 ? void 0 : ref17.Msg : "\uBC14\uB85C \uACAC\uC801 \uC694\uCCAD\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                        }
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function directConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    // 데이터 입력
    var methods = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(CustomizingSchema)
    });
    var onChangeUserInputs = function(e) {
        setCnt(e.target.value);
    };
    // 장바구니 담기 form submit
    var submitCart = function() {
        var _ref = new_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var temp, tempArr, body, res, content, ref, ref19, ref20, ref21;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(cnt === "")) {
                            _ctx.next = 5;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC785\uB825\uD558\uC2E0 \uB0B4\uC6A9\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.");
                        setCntError("\uC218\uB7C9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        setTimeout(function() {
                            window.scrollTo({
                                behavior: "smooth",
                                left: 0,
                                top: window.innerWidth > 991 ? cateRef.current.scrollHeight + 100 : cateRef.current.scrollHeight
                            });
                        }, [
                            200
                        ]);
                        return _ctx.abrupt("return");
                    case 5:
                        if (!(Object.values(data).includes("") || Object.values(data).includes(null) || Object.values(data).includes(undefined))) {
                            _ctx.next = 9;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uB0B4\uC6A9\uC744 \uC804\uBD80 \uCC44\uC6CC\uC8FC\uC138\uC694");
                        setTimeout(function() {
                            window.scrollTo({
                                behavior: "smooth",
                                left: 0,
                                top: window.innerWidth > 991 ? cateRef.current.scrollHeight + 100 : cateRef.current.scrollHeight
                            });
                        }, [
                            200
                        ]);
                        return _ctx.abrupt("return");
                    case 9:
                        temp = Object.keys(data);
                        tempArr = temp.map(function(el) {
                            return {
                                code: el,
                                value: data[el]
                            };
                        });
                        body = {
                            modes: "InsertSet",
                            dcode: category.code,
                            cnt: cnt,
                            items: JSON.stringify(tempArr)
                        };
                        _ctx.next = 14;
                        return (0,packagingBasket/* PackagingInsertSet */.so)(body);
                    case 14:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 22;
                            break;
                        }
                        (0,common_alert/* successAlert */.Cq)("\uACAC\uC801 \uBC14\uAD6C\uB2C8\uC5D0 \uB2F4\uACBC\uC2B5\uB2C8\uB2E4.");
                        _ctx.next = 19;
                        return queryClient.invalidateQueries([
                            "listSet"
                        ]);
                    case 19:
                        content = {
                            title: "\uACAC\uC801 \uBC14\uAD6C\uB2C8\uB85C \uC774\uB3D9\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                            actionBtnLabel: "\uD655\uC778",
                            actionBtnValid: true,
                            cancelBtnLabel: "\uACAC\uC801 \uCD94\uAC00",
                            onClose: function() {
                                _$closeConfirmModal();
                                router.reload();
                            },
                            onAction: function() {
                                router.push("/customizing/customizing-cart");
                                _$closeConfirmModal();
                            }
                        };
                        _$modifyConfirmModal(content);
                        _$openConfirmModal();
                    case 22:
                        if (res.Code === "8888") {
                            ;
                            setCnt((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Cnt);
                            (0,common_alert/* failAlert */.qh)(((ref19 = res.Data) === null || ref19 === void 0 ? void 0 : ref19.Msg) ? res.Data.Msg : "\uC81C\uC791\uAC00\uB2A5\uD55C \uC218\uB7C9\uC744 \uD655\uC778\uD574\uC8FC\uC138\uC694.");
                        }
                        if (res.Code === "9999") {
                            ;
                            (0,common_alert/* failAlert */.qh)(((ref20 = res.Data) === null || ref20 === void 0 ? void 0 : ref20.Msg) ? (ref21 = res.Data) === null || ref21 === void 0 ? void 0 : ref21.Msg : "\uACAC\uC801 \uBC14\uAD6C\uB2C8 \uB2F4\uAE30\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                        }
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitCart(data) {
            return _ref.apply(this, arguments);
        };
    }();
    // 유저 여부
    var checkUser = function() {
        var _ref = new_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,getUserInfo/* getUserInfo */.bG)();
                    case 2:
                        res = _ctx.sent;
                        if (res.code === "0000") setIsUser(true);
                        if (res.code !== "0000") {
                            setIsUser(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkUser() {
            return _ref.apply(this, arguments);
        };
    }();
    // 장바구니 삭제
    var deleteBasketItem = function() {
        var _ref = new_asyncToGenerator(runtime_default().mark(function _callee1(id) {
            var content;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        content = {
                            title: "\uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                            actionBtnLabel: "\uD655\uC778",
                            actionBtnValid: true,
                            cancelBtnLabel: "\uCDE8\uC18C",
                            onAction: new_asyncToGenerator(runtime_default().mark(function _callee() {
                                var body, res;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            body = {
                                                modes: "DeleteSet",
                                                id: id
                                            };
                                            _ctx.next = 3;
                                            return (0,packagingBasket/* PackagingDeleteSet */.$8)(body);
                                        case 3:
                                            res = _ctx.sent;
                                            if (!(res.Code === "0000")) {
                                                _ctx.next = 11;
                                                break;
                                            }
                                            (0,common_alert/* successAlert */.Cq)("\uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                                            _ctx.next = 8;
                                            return refetchBasket();
                                        case 8:
                                            _$closeConfirmModal();
                                            _ctx.next = 12;
                                            break;
                                        case 11:
                                            {
                                                (0,common_alert/* failAlert */.qh)("\uC0AD\uC81C\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                                            }
                                        case 12:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }))
                        };
                        _$modifyConfirmModal(content);
                        _$openConfirmModal();
                    case 3:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function deleteBasketItem(id) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        setCateLoading(true);
        if (router.query.code) {
            setCateLoading(false);
            setCnt("");
            methods.reset({});
            setCategory({
                code: router.query.code
            });
        // fetchCategoryDetail(router.query.code);
        } else {
            setCateLoading(false);
            if (router.query.first) return setCategory("");
            if (router.query.type) return;
            (0,common_alert/* failAlert */.qh)("\uCE74\uD14C\uACE0\uB9AC\uB97C \uBA3C\uC800 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.");
            router.push("/customizing/customizing-products/");
        }
    }, [
        router.isReady,
        router.query
    ]);
    (0,react.useEffect)(function() {
        refetchBasket();
        checkUser();
    }, []);
    (0,react.useEffect)(function() {
        if (detailData && router.query.code) {
            setCateLoading(false);
            if (router.query.code === "M0039") {
                setCnt("1");
            }
        }
    }, [
        detailData
    ]);
    var ref12 = (0,react.useState)([]), introductions = ref12[0], setIntroductions = ref12[1];
    var ref13 = (0,react.useState)({
        show: false,
        title: "\uC81C\uBAA9",
        image: ""
    }), modalContents = ref13[0], setModalContents = ref13[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            noBreadcrumb: "d-none",
            parent: "\uD648",
            sub: "\uB9DE\uCDA4\uC81C\uC791",
            subTitle: "\uACAC\uC801\uC694\uCCAD",
            pageTitle: SeoMeta/* SeoMeta.estimateRequest.title */.e.estimateRequest.title,
            pageDesc: SeoMeta/* SeoMeta.estimateRequest.description */.e.estimateRequest.description,
            pageKeyword: SeoMeta/* SeoMeta.estimateRequest.description */.e.estimateRequest.description,
            children: [
                cateLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loading_container position-fixed d-flex align-items-center justify-content-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        animation: "border",
                        role: "status"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* CustomNewSection */.$P, {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cateWrapper mt-15",
                            ref: function(ref) {
                                return cateRef.current = ref;
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizingCate/* default */.Z, {
                                cateRef: cateRef
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(new_CustomizingHeader, {
                                    isUser: isUser,
                                    dummyList: dummyList,
                                    basketData: basketData || [],
                                    category: category,
                                    gallery: galleryData,
                                    deleteBasketItem: deleteBasketItem
                                }),
                                detailData && router.query.code && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* StepSection */.DQ, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* StickyContents */._n, {
                                            className: "m_sticky",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* SideImageWrapper */.i_, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: detailData.Image,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* SideInfoWrapper */.Hd, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            className: "title",
                                                            children: "\uC0C1\uD488 \uC548\uB0B4 \uC0AC\uD56D"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            className: "ment",
                                                            children: (detailData === null || detailData === void 0 ? void 0 : detailData.Ment) !== undefined && (detailData === null || detailData === void 0 ? void 0 : detailData.Ment) !== null && ((ref18 = detailData.Ment) === null || ref18 === void 0 ? void 0 : ref18.map(function(el, i) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: el
                                                                }, i);
                                                            }))
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, new_objectSpread({}, methods, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                onSubmit: methods.handleSubmit(function(data) {
                                                    return submitCart(data);
                                                }),
                                                style: {
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* BodyWrapper */.ef, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* SideStickyWrapper */.lt, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* StickyContents */._n, {
                                                                    className: "pc_sticky",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Customizing_styles/* SideImageWrapper */.i_, {
                                                                            children: detailData.Images && detailData.Images.length > 0 ? detailData.Images.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(new_ImageSlider, {
                                                                                slides: detailData.Images
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                src: ((ref1 = detailData.Images[0]) === null || ref1 === void 0 ? void 0 : ref1.url) || detailData.Image,
                                                                                alt: "product-image",
                                                                                width: 390,
                                                                                height: 390,
                                                                                style: {
                                                                                    width: "100%",
                                                                                    maxWidth: "90%",
                                                                                    height: "auto",
                                                                                    objectFit: "contain",
                                                                                    margin: "0 auto"
                                                                                }
                                                                            }) : // Images 배열이 비어있을 때 기본 이미지 표시
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                src: "https://file.caretbio.com/caretbio/0333577f5ebffe01e5fdb76d8479a7f1.jpeg",
                                                                                alt: "product-image",
                                                                                width: 390,
                                                                                height: 390,
                                                                                style: {
                                                                                    width: "100%",
                                                                                    maxWidth: "90%",
                                                                                    height: "auto",
                                                                                    objectFit: "contain",
                                                                                    margin: "0 auto"
                                                                                }
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Customizing_styles/* SideInfoWrapper */.Hd, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "top",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                            className: "title",
                                                                                            children: "\uC0C1\uD488 \uC548\uB0B4 \uC0AC\uD56D"
                                                                                        }),
                                                                                        (category === null || category === void 0 ? void 0 : category.code) === "M0039" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                            href: ((ref2 = introductions.find(function(el) {
                                                                                                return el.code === "F2313";
                                                                                            })) === null || ref2 === void 0 ? void 0 : ref2.url) || "",
                                                                                            target: "_blank",
                                                                                            download: "\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u1105\u1175\u1111\u1165\u11AF\u1111\u1173\u1110\u1166\u110B\u1175\u1111\u1173.pdf",
                                                                                            children: "\uC790\uB8CC \uB2E4\uC6B4\uB85C\uB4DC"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                    className: "ment",
                                                                                    children: (detailData === null || detailData === void 0 ? void 0 : detailData.Ment) !== undefined && (detailData === null || detailData === void 0 ? void 0 : detailData.Ment) !== null && ((ref3 = detailData.Ment) === null || ref3 === void 0 ? void 0 : ref3.map(function(el, i) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                            children: el
                                                                                        }, i);
                                                                                    }))
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsDetail, {
                                                                detailData: detailData,
                                                                category: category,
                                                                onChangeUserInputs: onChangeUserInputs,
                                                                directConfirm: directConfirm,
                                                                isUser: isUser,
                                                                cnt: cnt,
                                                                cntError: cntError,
                                                                setIntroductions: setIntroductions,
                                                                modalContents: modalContents,
                                                                setModalContents: setModalContents
                                                            })
                                                        ]
                                                    }),
                                                    modalContents.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(customizingProducts_CustomizingModal, {
                                                        modalContents: modalContents,
                                                        setModalContents: setModalContents
                                                    })
                                                ]
                                            })
                                        }))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
var mapDispatchToProps = {
    openConfirmModal: action_confirm/* openConfirmModal */._5,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6
};
/* harmony default export */ var customizing_products_new = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(CustomizingDetailPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,7533,9382,5632,4027,4754,711,9774,2888,179], function() { return __webpack_exec__(7552); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);